import { render, staticRenderFns } from "./ClientesAnmac.vue?vue&type=template&id=0de970b8&scoped=true&"
import script from "./ClientesAnmac.vue?vue&type=script&lang=js&"
export * from "./ClientesAnmac.vue?vue&type=script&lang=js&"
import style0 from "./ClientesAnmac.vue?vue&type=style&index=0&id=0de970b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de970b8",
  null
  
)

export default component.exports